export enum FundingErrorInformation {
    conscientiousObjection = 'conscientiousObjection',
    foreignInsurance = 'foreignInsurance',
    invoicingAtGpPractice = 'invoicingAtGpPractice',
    other = 'other',
    patientDied = 'patientDied',
    rmo = 'rmo',
    uninsuredPatient = 'uninsuredPatient',
    wlz = 'wlz',
}
